class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		const customSortByOptions = this.querySelectorAll('.sort-by--item label');
		
		if (customSortByOptions.length > 0) {

			customSortByOptions.forEach(option => {
				option.addEventListener('keydown', (event) => {
					
					if (event.key === 'Enter' || event.keyCode === 13) {
						event.preventDefault();
						option.click(); 
					}
				});
			})
		}

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', (event) => {
        if (
          FacetFiltersForm.usesCustomTagFiltering() &&
          event.target.closest('.custom-menu-tag-filter input[name="filter.p.tag"]')
        ) {
          FacetFiltersForm.setCustomGridLoading(true);
        }
      });
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    FacetFiltersForm.syncCustomMenuTagFilterActiveStates();
  }

	static verticalFIlterBtn = document.querySelector('vertical-filter-button');
  static setListeners() {
    const onHistoryChange = (event) => {
      if (FacetFiltersForm.usesCustomTagFiltering()) {
        FacetFiltersForm.renderCustomTagResultsFromUrl(false);
        return;
      }
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
    document.addEventListener('click', FacetFiltersForm.onCustomMenuTagFilterClearClick);
    document.addEventListener('click', FacetFiltersForm.onCustomMenuTagFilterSummaryClick);
    document.addEventListener('keydown', FacetFiltersForm.onCustomMenuTagFilterSummaryKeydown);
    document.addEventListener('click', FacetFiltersForm.onCustomTagPaginationClick);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    FacetFiltersForm.renderRequestId += 1;
    const requestId = FacetFiltersForm.renderRequestId;
    FacetFiltersForm.requestController?.abort();
    FacetFiltersForm.requestController = new AbortController();
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, requestId)
        : FacetFiltersForm.renderSectionFromFetch(
            url,
            event,
            requestId,
            FacetFiltersForm.requestController.signal
          );
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

		FacetFiltersForm.updateFocusableItems();
  }
	
	static updateFocusableItems() {
		const grid = document.querySelector('.facets-top + .facets-vertical');
		if (!grid) return;

		const focusableItems = grid.querySelectorAll('.facets-wrapper :is(input:not(.field__range), summary, select, button, a, textarea)')
		if (focusableItems.length == 0) return;

		const focusable = grid.classList.contains('js-active');
		focusableItems.forEach((el) => {
			el.tabIndex = focusable ? 0 : -1;
		});

		const customSortByOptions = document.querySelectorAll('.sort-by--item label');
		
		if (customSortByOptions.length > 0) {

			customSortByOptions.forEach(option => {
				option.addEventListener('keydown', (event) => {
					
					if (event.key === 'Enter' || event.keyCode === 13) {
						event.preventDefault();
						option.click(); 
					}
				});
			})
		}
	}

  static renderSectionFromFetch(url, event, requestId, signal) {
    fetch(url, { signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        if (requestId !== FacetFiltersForm.renderRequestId) return;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      })
      .catch((error) => {
        if (error.name !== 'AbortError') throw error;
      });

		FacetFiltersForm.updateFocusableItems();
  }

  static renderSectionFromCache(filterDataUrl, event, requestId) {
    if (requestId !== FacetFiltersForm.renderRequestId) return;
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    const verticalFilterButton = document.querySelector('vertical-filter-button');
    if (verticalFilterButton && typeof verticalFilterButton.updateGridColumns === 'function') {
      verticalFilterButton.updateGridColumns(verticalFilterButton.hasAttribute('open') ? 'reset' : 'increase');
    }

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const customMenuOpenState = FacetFiltersForm.getCustomMenuTagFilterOpenState();
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      if (jsFilter && jsFilter.id && jsFilter.id.startsWith('Details-custom-menu-tag-filter-')) return false;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        // if (newElementToActivate) newElementToActivate.focus();
      }
    }

    FacetFiltersForm.syncCustomMenuTagFilterActiveStates();
    FacetFiltersForm.restoreCustomMenuTagFilterOpenState(customMenuOpenState);
		FacetFiltersForm.updateFocusableItems();
  }

  static getCustomMenuTagFilterDetailsKey(details) {
    const form = details.closest('form');
    const summary = details.querySelector(':scope > summary');
    const summaryInput = summary?.querySelector('input[type="checkbox"]');
    const toggle = summary?.querySelector('[aria-label]');
    const type = details.classList.contains('custom-menu-tag-filter__nested-subfilter') ? 'nested' : 'group';
    const value = summaryInput
      ? `${summaryInput.name}:${summaryInput.value}`
      : toggle?.getAttribute('aria-label');

    return form?.id && value ? `${form.id}|${type}|${value}` : null;
  }

  static getCustomMenuTagFilterOpenState() {
    return new Set(
      [...document.querySelectorAll('.custom-menu-tag-filter details[open]')]
        .map((details) => FacetFiltersForm.getCustomMenuTagFilterDetailsKey(details))
        .filter(Boolean)
    );
  }

  static restoreCustomMenuTagFilterOpenState(openState) {
    if (!openState?.size) return;

    document.querySelectorAll('.custom-menu-tag-filter details').forEach((details) => {
      const key = FacetFiltersForm.getCustomMenuTagFilterDetailsKey(details);
      if (key && openState.has(key)) details.open = true;
    });
  }

  static syncCustomMenuTagFilterActiveStates() {
    const normalize = (value) => String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
    const currentParams = new URLSearchParams(window.location.search);
    const useCustomTagFilter = FacetFiltersForm.usesCustomTagFiltering();
    const customTagHandles = useCustomTagFilter ? FacetFiltersForm.getCustomSelectedTagHandles() : new Set();

    document
      .querySelectorAll('.custom-menu-tag-filter input[type="checkbox"]:not([data-custom-menu-tag-group-toggle])')
      .forEach((input) => {
        const selectedTags = new Set(currentParams.getAll(input.name).map(normalize));
        const isActive = useCustomTagFilter
          ? customTagHandles.has(FacetFiltersForm.normalizeCustomTagHandle(input.dataset.tagHandle))
          : selectedTags.has(normalize(input.value));
        input.checked = isActive;
        input.closest('.facets__label')?.classList.toggle('active', isActive);
      });

    FacetFiltersForm.normalizeCustomMenuSummaryCheckboxes();

    document.querySelectorAll('.custom-menu-tag-filter__subfilter').forEach((subfilter) => {
      const hasActiveOption = Boolean(subfilter.querySelector('input[type="checkbox"]:checked'));
      subfilter.querySelector('.custom-menu-tag-filter__subfilter-summary')?.classList.toggle('active', hasActiveOption);
      if (hasActiveOption) subfilter.open = true;
    });

    document.querySelectorAll('[data-custom-menu-tag-filter-subfilter]').forEach((subfilter) => {
      const checkedInputs = subfilter.querySelectorAll(
        'input[type="checkbox"]:checked:not([data-custom-menu-tag-group-toggle])'
      );
      const selectedCount = checkedInputs.length;
      const summary = subfilter.querySelector('.custom-menu-tag-filter__nested-summary');
      const status = subfilter.querySelector('[data-custom-menu-tag-filter-selection-status]');
      const selectedCountText = subfilter.querySelector('[data-custom-menu-tag-filter-selected-count]');

      summary?.classList.toggle('active', selectedCount > 0);
      if (selectedCount > 0) subfilter.open = true;
      if (status) status.classList.toggle('hidden', selectedCount === 0);
      if (selectedCountText) {
        selectedCountText.textContent = window.themeStrings.filtersSelected.replace('[count]', selectedCount);
      }
    });

    FacetFiltersForm.renderMissingCustomMenuTagActiveFacets();
    FacetFiltersForm.updateCustomMenuTagGroupCounts();
    FacetFiltersForm.updateCustomMenuTagParentCounts();
  }

  static async updateCustomMenuTagGroupCounts() {
    const settings = document.querySelector('[data-active-facets-labels]');
    if (settings?.dataset.useNativeFilterCounts === 'true') return;

    const collectionHandle = settings?.dataset.collectionHandle;
    const countElements = document.querySelectorAll('[data-custom-menu-tag-current-count]');
    const leafCountElements = document.querySelectorAll('[data-custom-menu-tag-leaf-count]');
    if (!collectionHandle || (countElements.length === 0 && leafCountElements.length === 0)) return;

    try {
      const products = await FacetFiltersForm.loadCollectionProducts(collectionHandle);
      const settings = document.querySelector('[data-active-facets-labels]');
      const currentHandle = settings?.dataset.collectionHandle;
      const useCustomTagFilter = FacetFiltersForm.usesCustomTagFiltering();
      if (currentHandle !== collectionHandle) return;

      countElements.forEach((countElement) => {
        const group = countElement.closest('[data-custom-menu-tag-filter-subfilter]');
        const childTags = new Set(
          [...(group?.querySelectorAll('input[name="filter.p.tag"]') || [])]
            .map((input) =>
              useCustomTagFilter
                ? FacetFiltersForm.normalizeCustomTagHandle(input.dataset.tagHandle)
                : input.value.trim().toLowerCase()
            )
            .filter(Boolean)
        );
        if (childTags.size === 0) return;

        const count = products.filter((product) =>
          (product.tags || []).some((tag) =>
            childTags.has(useCustomTagFilter ? FacetFiltersForm.handleizeTag(tag) : String(tag).trim().toLowerCase())
          )
        ).length;
        countElement.textContent = count;
      });

      leafCountElements.forEach((countElement) => {
        const label = countElement.closest('.facets__label');
        const input = label?.querySelector('input[type="checkbox"]');
        const tagHandle = input?.dataset.tagHandle;
        const tagValue = input?.value.trim().toLowerCase();
        if (useCustomTagFilter ? !tagHandle : !tagValue) return;

        const count = products.filter((product) =>
          (product.tags || []).some((tag) =>
              useCustomTagFilter
              ? FacetFiltersForm.handleizeTag(tag) === FacetFiltersForm.normalizeCustomTagHandle(tagHandle)
              : String(tag).trim().toLowerCase() === tagValue
          )
        ).length;
        countElement.textContent = count;
        countElement.closest('[data-custom-menu-tag-leaf-count-wrapper]')?.removeAttribute('hidden');

        const shouldDisable = count === 0 && !input?.checked;
        if (input) input.disabled = shouldDisable;
        label?.classList.toggle('disabled', shouldDisable);
      });

      FacetFiltersForm.normalizeCustomMenuSummaryCheckboxes();
    } catch (error) {
      FacetFiltersForm.collectionProductsCache.delete(collectionHandle);
      console.warn(error);
    }
  }

  static handleizeTag(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/&/g, ' ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  static normalizeCustomTagHandle(handle) {
    if (handle === 'healthy-snacks-1') return 'healthy-snacks';
    return handle;
  }

  static usesCustomTagFiltering() {
    const searchParams = new URLSearchParams(window.location.search);
    return (
      document.querySelector('[data-active-facets-labels]')?.dataset.useCustomTagFilter === 'true' ||
      searchParams.has('tag') ||
      searchParams.has('custom_tag')
    );
  }

  static getCustomSelectedTagHandles(url = window.location.href) {
    const searchParams = new URL(url, window.location.origin).searchParams;
    return new Set(
      [...searchParams.getAll('tag'), ...searchParams.getAll('custom_tag')]
        .filter(Boolean)
        .map((handle) => FacetFiltersForm.normalizeCustomTagHandle(handle))
    );
  }

  static loadCollectionProducts(collectionHandle) {
    FacetFiltersForm.collectionProductsCache ||= new Map();
    if (!FacetFiltersForm.collectionProductsCache.has(collectionHandle)) {
      const productsPromise = (async () => {
        const productsById = new Map();
        let page = 1;
        let products = [];

        do {
          const response = await fetch(
            `/collections/${encodeURIComponent(collectionHandle)}/products.json?limit=250&page=${page}`
          );
          if (!response.ok) throw new Error(`Unable to load collection products: ${response.status}`);

          const data = await response.json();
          products = Array.isArray(data.products) ? data.products : [];
          products.forEach((product) => productsById.set(product.id, product));
          page += 1;
        } while (products.length === 250);

        return [...productsById.values()];
      })();
      FacetFiltersForm.collectionProductsCache.set(collectionHandle, productsPromise);
    }
    return FacetFiltersForm.collectionProductsCache.get(collectionHandle);
  }

  static sortCustomProducts(products, sortBy) {
    const sorted = [...products];
    const price = (product) => Math.min(...(product.variants || []).map((variant) => Number(variant.price) || 0));

    if (sortBy === 'title-ascending') sorted.sort((a, b) => a.title.localeCompare(b.title));
    if (sortBy === 'title-descending') sorted.sort((a, b) => b.title.localeCompare(a.title));
    if (sortBy === 'price-ascending') sorted.sort((a, b) => price(a) - price(b));
    if (sortBy === 'price-descending') sorted.sort((a, b) => price(b) - price(a));
    if (sortBy === 'created-ascending') sorted.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    if (sortBy === 'created-descending') sorted.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    return sorted;
  }

  static applyCustomNativeFilters(products, searchParams) {
    const vendors = new Set(searchParams.getAll('filter.p.vendor'));
    const minimumPrice = Number(searchParams.get('filter.v.price.gte'));
    const maximumPrice = Number(searchParams.get('filter.v.price.lte'));
    const hasMinimumPrice = searchParams.has('filter.v.price.gte') && Number.isFinite(minimumPrice);
    const hasMaximumPrice = searchParams.has('filter.v.price.lte') && Number.isFinite(maximumPrice);

    return products.filter((product) => {
      if (vendors.size > 0 && !vendors.has(product.vendor)) return false;
      if (!hasMinimumPrice && !hasMaximumPrice) return true;

      return (product.variants || []).some((variant) => {
        const price = Number(variant.price);
        if (!Number.isFinite(price)) return false;
        if (hasMinimumPrice && price < minimumPrice) return false;
        if (hasMaximumPrice && price > maximumPrice) return false;
        return true;
      });
    });
  }

  static async renderCustomProductCards(handles) {
    FacetFiltersForm.productCardCache ||= new Map();
    const root = window.Shopify?.routes?.root || '/';
    const renderCard = async (handle) => {
        if (FacetFiltersForm.productCardCache.has(handle)) {
          return FacetFiltersForm.productCardCache.get(handle);
        }

        const cardPromise = (async () => {
          const response = await fetch(
            `${root}products/${encodeURIComponent(handle)}?view=custom-filter-card-lite`
          );
          if (!response.ok) throw new Error(`Unable to render product card: ${response.status}`);
          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          return documentFragment.querySelector('[data-custom-filter-product-handle]')?.outerHTML || '';
        })();
        FacetFiltersForm.productCardCache.set(handle, cardPromise);
        return cardPromise;
    };
    const responses = [];
    const concurrency = 6;

    for (let index = 0; index < handles.length; index += concurrency) {
      responses.push(...(await Promise.all(handles.slice(index, index + concurrency).map(renderCard))));
    }

    return responses.filter(Boolean);
  }

  static renderCustomPagination(currentPage, totalPages) {
    const container = document.querySelector('#ProductGridContainer .collection');
    container?.querySelector('.pagination-wrapper')?.remove();
    if (!container || totalPages <= 1) return;

    const settings = document.querySelector('[data-active-facets-labels]');
    const arrowIcon = `
      <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false" class="icon icon-short-arrow" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.99823 0.137207L5.78898 1.34677L10.5745 6.14211H0.137207V7.85779H10.5745L5.78898 12.6531L6.99823 13.8627L13.8593 6.99995L6.99823 0.137207Z" fill="currentColor"/>
      </svg>
    `;
    const pageUrl = (page) => {
      const url = new URL(window.location.href);
      url.searchParams.delete('custom_page');
      if (page > 1) url.searchParams.set('custom_page', page);
      return `${url.pathname}${url.search}`;
    };
    const pageLabel = (page) => (settings?.dataset.paginationPage || 'Page [page]').replace('[page]', page);
    const wrapper = document.createElement('div');
    wrapper.className = 'pagination-wrapper';
    const pages = Array.from({ length: totalPages }, (_, index) => {
      const page = index + 1;
      return page === currentPage
        ? `<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--link link pagination__item--current light" aria-current="page" aria-label="${pageLabel(page)}"><span class="link-underline">${page}</span></a></li>`
        : `<li><a href="${pageUrl(page)}" class="pagination__item pagination__item--link link" data-custom-tag-page="${page}" aria-label="${pageLabel(page)}"><span class="link-underline">${page}</span></a></li>`;
    }).join('');
    const previousPage = Math.max(1, currentPage - 1);
    const nextPage = Math.min(totalPages, currentPage + 1);
    wrapper.innerHTML = `
      <nav class="pagination" role="navigation" aria-label="${settings?.dataset.paginationLabel || 'Pagination'}">
        <ul class="pagination__list list-unstyled${totalPages > 4 ? ' space-between' : ''}" role="list">
          <li>
            <a href="${pageUrl(previousPage)}" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce active${
              currentPage === 1 ? ' disabled' : ''
            }" data-custom-tag-page="${previousPage}" aria-label="${settings?.dataset.paginationPrevious || 'Previous page'}">${arrowIcon}</a>
          </li>
          ${pages}
          <li>
            <a href="${pageUrl(nextPage)}" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce active${
              currentPage === totalPages ? ' disabled' : ''
            }" data-custom-tag-page="${nextPage}" aria-label="${settings?.dataset.paginationNext || 'Next page'}">${arrowIcon}</a>
          </li>
        </ul>
      </nav>
    `;
    container.append(wrapper);
  }

  static updateCustomProductCount(count) {
    const settings = document.querySelector('[data-active-facets-labels]');
    const template = count === 1 ? settings?.dataset.productCountOne : settings?.dataset.productCountOther;
    const text = template ? template.replace(/\d+/, count) : String(count);
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((element) => {
      element.textContent = text;
      element.classList.remove('loading');
    });
  }

  static async updateCustomMenuTagParentCounts(productCount = null, selectedHandles = null) {
    const countElements = [...document.querySelectorAll('[data-custom-menu-tag-parent-count]')];
    if (countElements.length === 0) return;

    const setCount = (countElement, count) => {
      countElement.textContent = count;
      countElement.closest('[data-custom-menu-tag-parent-count-wrapper]')?.removeAttribute('hidden');
    };

    const isCustomTagFilter = FacetFiltersForm.usesCustomTagFiltering();

    if (isCustomTagFilter) {
      const activeHandles = selectedHandles || FacetFiltersForm.getCustomSelectedTagHandles();

      if (activeHandles.size > 0) {
        if (!Number.isFinite(productCount)) return;

        countElements.forEach((countElement) => {
          const group = countElement.closest('.custom-menu-tag-filter__subfilter');
          const groupHandles = new Set(
            [...(group?.querySelectorAll('input[name="filter.p.tag"]') || [])]
              .map((input) => FacetFiltersForm.normalizeCustomTagHandle(input.dataset.tagHandle))
              .filter(Boolean)
          );

          if ([...activeHandles].some((handle) => groupHandles.has(handle))) {
            setCount(countElement, productCount);
          }
        });
        return;
      }

      const settings = document.querySelector('[data-active-facets-labels]');
      const collectionHandle = settings?.dataset.collectionHandle;
      if (!collectionHandle) return;

      try {
        const products = await FacetFiltersForm.loadCollectionProducts(collectionHandle);
        countElements.forEach((countElement) => {
          const group = countElement.closest('.custom-menu-tag-filter__subfilter');
          const groupHandles = new Set(
            [...(group?.querySelectorAll('input[name="filter.p.tag"]') || [])]
              .map((input) => FacetFiltersForm.normalizeCustomTagHandle(input.dataset.tagHandle))
              .filter(Boolean)
          );
          const count = products.filter((product) =>
            (product.tags || []).some((tag) => groupHandles.has(FacetFiltersForm.handleizeTag(tag)))
          ).length;
          setCount(countElement, count);
        });
      } catch (error) {
        console.warn(error);
      }
      return;
    }

    const parentCountCache = (FacetFiltersForm.parentCountCache ||= new Map());
    const baseUrl = new URL(window.location.href);
    baseUrl.searchParams.delete('page');
    baseUrl.searchParams.delete('custom_page');
    baseUrl.searchParams.delete('filter.p.tag');

    const getCount = async (values) => {
      const url = new URL(baseUrl);
      values.forEach((value) => url.searchParams.append('filter.p.tag', value));
      const cacheKey = url.toString();

      if (!parentCountCache.has(cacheKey)) {
        parentCountCache.set(
          cacheKey,
          fetch(url)
            .then((response) => {
              if (!response.ok) throw new Error(`Unable to load filtered collection: ${response.status}`);
              return response.text();
            })
            .then((html) => {
              const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
              const countText = parsedHTML.querySelector('#ProductCountDesktop, #ProductCount')?.textContent || '';
              const countMatch = countText.match(/\d[\d\s.,]*/);
              return countMatch ? Number(countMatch[0].replace(/\D/g, '')) : null;
            })
        );
      }

      return parentCountCache.get(cacheKey);
    };

    countElements.forEach(async (countElement) => {
      const group = countElement.closest('.custom-menu-tag-filter__subfilter');
      const values = [
        ...new Set(
          [...(group?.querySelectorAll('input[name="filter.p.tag"]') || [])]
            .filter((input) => !input.hasAttribute('data-custom-menu-tag-group-toggle'))
            .map((input) => input.value)
            .filter(Boolean)
        ),
      ];
      if (values.length === 0) return;

      try {
        const count = await getCount(values);
        if (Number.isFinite(count)) setCount(countElement, count);
      } catch (error) {
        console.warn(error);
      }
    });
  }

  static setCustomGridLoading(isLoading) {
    const collection = document.getElementById('ProductGridContainer')?.querySelector('.collection');
    const grid = document.getElementById('product-grid');

    collection?.classList.toggle('loading', isLoading);
    grid?.setAttribute('aria-busy', String(isLoading));
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((element) => {
      element.classList.toggle('loading', isLoading);
    });
  }

  static async renderCustomTagResultsFromUrl(updateHistory = true, requestedPage = null) {
    const settings = document.querySelector('[data-active-facets-labels]');
    const collectionHandle = settings?.dataset.collectionHandle;
    const grid = document.getElementById('product-grid');
    if (!collectionHandle || !grid) return;

    const currentUrl = new URL(window.location.href);
    const selectedHandles = FacetFiltersForm.getCustomSelectedTagHandles(currentUrl.href);
    const page = Math.max(1, requestedPage || Number(currentUrl.searchParams.get('custom_page')) || 1);
    const perPage = Math.max(1, Number(settings.dataset.productsPerPage) || 24);
    const sortBy = currentUrl.searchParams.get('sort_by') || 'manual';
    FacetFiltersForm.customRenderRequestId = (FacetFiltersForm.customRenderRequestId || 0) + 1;
    const requestId = FacetFiltersForm.customRenderRequestId;
    const loadingStartedAt = Date.now();

    FacetFiltersForm.setCustomGridLoading(true);
    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

    try {
      const products = await FacetFiltersForm.loadCollectionProducts(collectionHandle);
      const filtered =
        selectedHandles.size === 0
          ? products
          : products.filter((product) =>
              (product.tags || []).some((tag) => selectedHandles.has(FacetFiltersForm.handleizeTag(tag)))
            );
      const nativeFiltered = FacetFiltersForm.applyCustomNativeFilters(filtered, currentUrl.searchParams);
      const sorted = FacetFiltersForm.sortCustomProducts(nativeFiltered, sortBy);
      const totalPages = Math.max(1, Math.ceil(sorted.length / perPage));
      const safePage = Math.min(page, totalPages);
      const pageProducts = sorted.slice((safePage - 1) * perPage, safePage * perPage);
      const cards = await FacetFiltersForm.renderCustomProductCards(pageProducts.map((product) => product.handle));
      if (requestId !== FacetFiltersForm.customRenderRequestId) return;

      grid.innerHTML =
        cards.length > 0
          ? cards.join('')
          : `<li class="grid__item grid__item--full-width">${settings.dataset.noProducts || ''}</li>`;
      FacetFiltersForm.renderCustomPagination(safePage, totalPages);
      FacetFiltersForm.updateCustomProductCount(sorted.length);
      FacetFiltersForm.updateCustomMenuTagParentCounts(sorted.length, selectedHandles);
      FacetFiltersForm.syncCustomMenuTagFilterActiveStates();

      currentUrl.searchParams.delete('custom_page');
      if (safePage > 1) currentUrl.searchParams.set('custom_page', safePage);
      if (updateHistory) history.pushState({}, '', `${currentUrl.pathname}${currentUrl.search}`);
    } catch (error) {
      if (requestId === FacetFiltersForm.customRenderRequestId) console.warn(error);
    } finally {
      if (requestId === FacetFiltersForm.customRenderRequestId) {
        const remainingLoadingTime = Math.max(0, 250 - (Date.now() - loadingStartedAt));
        if (remainingLoadingTime > 0) {
          await new Promise((resolve) => setTimeout(resolve, remainingLoadingTime));
        }
        FacetFiltersForm.setCustomGridLoading(false);
      }
    }
  }

  static onCustomTagPaginationClick(event) {
    const button = event.target.closest('[data-custom-tag-page]');
    if (!button) return;
    event.preventDefault();
    FacetFiltersForm.renderCustomTagResultsFromUrl(true, Number(button.dataset.customTagPage)).then(() => {
      const gridContainer = document.getElementById('ProductGridContainer');
      if (!gridContainer) return;

      window.scrollTo({
        top: gridContainer.getBoundingClientRect().top + window.scrollY - 300,
        behavior: 'smooth',
      });
    });
  }

  static normalizeCustomMenuSummaryCheckboxes(scope = document) {
    scope.querySelectorAll('[data-custom-menu-tag-group-toggle]').forEach((groupCheckbox) => {
      const details = groupCheckbox.closest('details');
      const descendantInputs = [
        ...(details?.querySelectorAll(
          'input[type="checkbox"]:not([data-custom-menu-tag-group-toggle]):not(:disabled)'
        ) || []),
      ];
      const checkedCount = descendantInputs.filter((input) => input.checked).length;

      groupCheckbox.checked = descendantInputs.length > 0 && checkedCount === descendantInputs.length;
      groupCheckbox.indeterminate = checkedCount > 0 && checkedCount < descendantInputs.length;
    });
  }

  static toggleCustomMenuTagGroup(checkbox) {
    const details = checkbox.closest('details');
    const descendantInputs = [
      ...(details?.querySelectorAll(
        'input[type="checkbox"]:not([data-custom-menu-tag-group-toggle]):not(:disabled)'
      ) || []),
    ];
    if (descendantInputs.length === 0) return;

    const shouldCheck = !descendantInputs.every((input) => input.checked);
    descendantInputs.forEach((input) => {
      input.checked = shouldCheck;
    });
    FacetFiltersForm.normalizeCustomMenuSummaryCheckboxes(details.closest('form') || document);
    descendantInputs[0].dispatchEvent(new Event('input', { bubbles: true }));
  }

  static renderMissingCustomMenuTagActiveFacets() {
    const customFilter = document.querySelector('.custom-menu-tag-filter');
    if (!customFilter) {
      FacetFiltersForm.initializeActiveFacetsShowMore();
      return;
    }

    const normalize = (value) => String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
    const checkedInputs = [
      ...customFilter.querySelectorAll(
        'input[name="filter.p.tag"]:checked:not([data-custom-menu-tag-group-toggle]):not(:disabled)'
      ),
    ];
    const activeFacetContainers = [
      ...document.querySelectorAll('.active-facets-desktop'),
      ...document.querySelectorAll('.active-facets-mobile .active-facets__list'),
    ];

    document.querySelectorAll('[data-custom-menu-tag-active-facet]').forEach((facet) => facet.remove());
    if (checkedInputs.length === 0 || activeFacetContainers.length === 0) {
      FacetFiltersForm.initializeActiveFacetsShowMore();
      return;
    }

    const getInputKey = (input) =>
      FacetFiltersForm.normalizeCustomTagHandle(input.dataset.tagHandle) || `${input.name}:${normalize(input.value)}`;
    const getInputPriority = (input) => {
      if (input.closest('.custom-menu-tag-filter__nested-list')) return 3;
      if (input.closest('.custom-menu-tag-filter__subfilter-list')) return 2;
      if (input.closest('.custom-menu-tag-filter__subfilter-label')) return 1;
      return 0;
    };
    const getInputLabel = (input) => {
      const labelText =
        input.closest('.facet-checkbox')?.querySelector('.facet-checkbox__text, .custom-menu-tag-filter__subfilter-title, .custom-menu-tag-filter__nested-title')?.textContent ||
        input.value;
      return labelText.replace(/\s*\(\s*\d+\s*\)\s*$/, '').trim();
    };
    const getRemoveUrl = (input) => {
      const currentUrl = new URL(window.location.href);
      const nextParams = new URLSearchParams();
      const valuesToRemove = new Map();
      const handlesToRemove = new Set();
      const useCustomTagFilter = FacetFiltersForm.usesCustomTagFiltering();

      if (input.hasAttribute('data-custom-menu-tag-group-toggle')) {
        input
          .closest('details')
          ?.querySelectorAll(
            'input[type="checkbox"]:checked:not([data-custom-menu-tag-group-toggle]):not(:disabled)'
          )
          .forEach((descendantInput) => {
            if (!descendantInput.name) return;
            if (descendantInput.dataset.tagHandle) handlesToRemove.add(descendantInput.dataset.tagHandle);
            if (!valuesToRemove.has(descendantInput.name)) valuesToRemove.set(descendantInput.name, new Set());
            valuesToRemove.get(descendantInput.name).add(normalize(descendantInput.value));
          });
      } else if (input.name) {
        if (input.dataset.tagHandle) handlesToRemove.add(input.dataset.tagHandle);
        valuesToRemove.set(input.name, new Set([normalize(input.value)]));
      }

      if (useCustomTagFilter) {
        const remainingHandles = [...FacetFiltersForm.getCustomSelectedTagHandles()].filter(
          (handle) => !handlesToRemove.has(handle)
        );
        currentUrl.searchParams.delete('tag');
        currentUrl.searchParams.delete('custom_tag');
        currentUrl.searchParams.delete('custom_page');
        remainingHandles.forEach((handle) => currentUrl.searchParams.append('tag', handle));
        return `${currentUrl.pathname}${currentUrl.search}`;
      }

      currentUrl.searchParams.forEach((value, key) => {
        if (valuesToRemove.get(key)?.has(normalize(value))) return;
        nextParams.append(key, value);
      });

      const queryString = nextParams.toString();
      return `${currentUrl.pathname}${queryString ? `?${queryString}` : ''}`;
    };

    const uniqueCheckedInputs = [...checkedInputs.reduce((selectedInputs, input) => {
      const key = getInputKey(input);
      const selectedInput = selectedInputs.get(key);
      if (!selectedInput || getInputPriority(input) > getInputPriority(selectedInput)) {
        selectedInputs.set(key, input);
      }
      return selectedInputs;
    }, new Map()).values()];

    uniqueCheckedInputs.forEach((input) => {
      const inputLabel = getInputLabel(input);
      const removeUrl = getRemoveUrl(input);

      activeFacetContainers.forEach((container) => {
        const hasMatchingFacet = [...container.querySelectorAll('.active-facets__button')].some((button) =>
          normalize(button.textContent).includes(normalize(inputLabel))
        );
        if (hasMatchingFacet) return;

        const template = document.createElement('template');
        template.innerHTML = `
          <facet-remove data-custom-menu-tag-active-facet>
            <a class="active-facets__button active-facets__button--light" href="${removeUrl}">
              <span class="active-facets__button-inner button button--secondary button--outline">
                ${inputLabel}
                <svg class="icon icon-close-small" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                  <path d="M9.54569 9.54569C9.44522 9.64616 9.30896 9.7026 9.16688 9.7026C9.0248 9.7026 8.88854 9.64616 8.78807 9.54569L5 5.75762L1.21193 9.54569C1.11146 9.64616 0.975201 9.7026 0.833121 9.7026C0.69104 9.7026 0.55478 9.64616 0.454314 9.54569C0.353848 9.44522 0.297406 9.30896 0.297407 9.16688C0.297407 9.0248 0.353848 8.88854 0.454314 8.78807L4.24239 5L0.454314 1.21193C0.353848 1.11146 0.297407 0.975204 0.297407 0.833124C0.297406 0.691044 0.353848 0.554783 0.454314 0.454317C0.55478 0.353851 0.691041 0.29741 0.833121 0.29741C0.975201 0.29741 1.11146 0.353851 1.21193 0.454317L5 4.24239L8.78807 0.454317C8.88854 0.353851 9.0248 0.29741 9.16688 0.29741C9.30896 0.29741 9.44522 0.353851 9.54569 0.454317C9.64615 0.554783 9.70259 0.691044 9.70259 0.833124C9.70259 0.975204 9.64615 1.11146 9.54569 1.21193L5.75761 5L9.54569 8.78807C9.64615 8.88854 9.70259 9.0248 9.70259 9.16688C9.70259 9.30896 9.64615 9.44522 9.54569 9.54569Z" fill="currentColor"/>
                </svg>
                <span class="visually-hidden">${window.themeStrings.clearFilter}</span>
              </span>
            </a>
          </facet-remove>
        `;
        container.append(template.content.firstElementChild);
      });
    });

    FacetFiltersForm.initializeActiveFacetsShowMore();
  }

  static initializeActiveFacetsShowMore() {
    const visibleFacetCount = 5;
    const labels = document.querySelector('[data-active-facets-labels]');
    const showMoreLabel = labels?.dataset.showMore || window.themeStrings.showMore;
    const showLessLabel = labels?.dataset.showLess || window.themeStrings.showLess;
    const shouldExpand = FacetFiltersForm.activeFacetsExpanded === true;
    const containers = [...document.querySelectorAll('.active-facets-desktop')];

    containers.forEach((container) => {
      container.querySelector('[data-active-facets-toggle]')?.remove();
      const facets = [...container.querySelectorAll(':scope > facet-remove')].filter((facet) =>
        facet.querySelector('.active-facets__button')
      );

      facets.forEach((facet) => facet.classList.remove('hidden'));
      if (facets.length <= visibleFacetCount) return;

      facets.slice(visibleFacetCount).forEach((facet) => facet.classList.toggle('hidden', !shouldExpand));

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button-show-more link underlined-link no-js-hidden';
      button.dataset.activeFacetsToggle = '';
      button.setAttribute('aria-expanded', String(shouldExpand));
      button.textContent = shouldExpand ? showLessLabel : showMoreLabel;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        FacetFiltersForm.activeFacetsExpanded = expanded;
        facets.slice(visibleFacetCount).forEach((facet) => facet.classList.toggle('hidden', !expanded));
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? showLessLabel : showMoreLabel;
      });
      container.append(button);
    });
  }

  static onCustomMenuTagFilterClearClick(event) {
    const clearButton = event.target.closest('[data-custom-menu-tag-filter-clear]');
    if (!clearButton) return;

    event.preventDefault();
    const subfilter = clearButton.closest('[data-custom-menu-tag-filter-subfilter]');
    if (!subfilter) return;

    const checkedInputs = [...subfilter.querySelectorAll('input[name="filter.p.tag"]:checked')];
    const valuesToRemove = new Set(checkedInputs.map((input) => input.value));
    if (valuesToRemove.size === 0) return;

    if (FacetFiltersForm.usesCustomTagFiltering()) {
      checkedInputs.forEach((input) => {
        input.checked = false;
      });
      checkedInputs[0].dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    const currentParams = new URLSearchParams(window.location.search);
    const nextParams = new URLSearchParams();

    currentParams.forEach((value, key) => {
      if (key === 'filter.p.tag' && valuesToRemove.has(value)) return;
      nextParams.append(key, value);
    });

    FacetFiltersForm.renderPage(nextParams.toString(), event);
  }

  static onCustomMenuTagFilterSummaryClick(event) {
    const summary = event.target.closest('.custom-menu-tag-filter__subfilter-summary, .custom-menu-tag-filter__nested-summary');
    if (!summary) return;

    const checkboxLabel = event.target.closest('[data-custom-menu-tag-summary-checkbox-label]');
    if (checkboxLabel && summary.contains(checkboxLabel)) {
      event.preventDefault();
      event.stopPropagation();

      const checkbox = checkboxLabel.querySelector('input[type="checkbox"]');
      if (!checkbox || checkbox.disabled) return;

      if (checkbox.hasAttribute('data-custom-menu-tag-group-toggle')) {
        FacetFiltersForm.toggleCustomMenuTagGroup(checkbox);
        return;
      }

      checkbox.checked = !checkbox.checked;
      if (checkbox.checked) {
        const details = checkbox.closest('details');
        const innerList = details?.querySelector('.custom-menu-tag-filter__subfilter-list, .custom-menu-tag-filter__nested-list');
        innerList?.querySelectorAll('input[type="checkbox"]:checked').forEach((innerCheckbox) => {
          innerCheckbox.checked = false;
        });
      }
      checkbox.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    const toggleIcon = event.target.closest(
      '.custom-menu-tag-filter__subfilter-icon, .custom-menu-tag-filter__nested-icon, .mobile-facets__arrow'
    );
    if (toggleIcon && summary.contains(toggleIcon)) return;

    event.preventDefault();
  }

  static onCustomMenuTagFilterSummaryKeydown(event) {
    const isToggleKey = event.key === 'Enter' || event.key === ' ';
    if (!isToggleKey) return;

    const summary = event.target.closest('.custom-menu-tag-filter__subfilter-summary, .custom-menu-tag-filter__nested-summary');
    if (!summary) return;

    const checkboxLabel = event.target.closest('[data-custom-menu-tag-summary-checkbox-label]');
    if (checkboxLabel && summary.contains(checkboxLabel)) {
      event.preventDefault();

      const checkbox = checkboxLabel.querySelector('input[type="checkbox"]');
      if (!checkbox || checkbox.disabled) return;

      if (checkbox.hasAttribute('data-custom-menu-tag-group-toggle')) {
        FacetFiltersForm.toggleCustomMenuTagGroup(checkbox);
        return;
      }

      checkbox.checked = !checkbox.checked;
      if (checkbox.checked) {
        const details = checkbox.closest('details');
        const innerList = details?.querySelector('.custom-menu-tag-filter__subfilter-list, .custom-menu-tag-filter__nested-list');
        innerList?.querySelectorAll('input[type="checkbox"]:checked').forEach((innerCheckbox) => {
          innerCheckbox.checked = false;
        });
      }
      checkbox.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    event.preventDefault();

    const toggleIcon = event.target.closest(
      '.custom-menu-tag-filter__subfilter-icon, .custom-menu-tag-filter__nested-icon, .mobile-facets__arrow'
    );
    if (!toggleIcon || !summary.contains(toggleIcon)) return;

    const details = summary.closest('details');
    if (details) details.open = !details.open;
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    FacetFiltersForm.activeFacetsExpanded = Boolean(
      document.querySelector('[data-active-facets-toggle][aria-expanded="true"]')
    );

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    FacetFiltersForm.normalizeCustomMenuSummaryCheckboxes(form);

    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);

    // Remove empty fields so they don't become active filters (e.g. price gte/lte).
    [...new Set([...searchParams.keys()])].forEach((key) => {
      const values = searchParams.getAll(key);
      if (values.length > 0 && values.every((value) => value === '')) {
        searchParams.delete(key);
      }
    });

    // Prevent default price range (0..max) from becoming an "active" filter.
    const priceGteInput = form.querySelector('input[name*="price.gte"]');
    const priceLteInput = form.querySelector('input[name*="price.lte"]');

    if (priceGteInput && priceLteInput) {
      const gteKey = priceGteInput.name;
      const lteKey = priceLteInput.name;

      const toNumber = (value) => {
        if (value == null) return null;
        const normalized = String(value).trim().replace(/\s+/g, '').replace(',', '.');
        if (normalized === '') return null;
        const n = Number(normalized);
        return Number.isFinite(n) ? n : null;
      };

      const gteValue = searchParams.get(gteKey);
      const lteValue = searchParams.get(lteKey);
      const lteMax = priceLteInput.getAttribute('max');

      const gteNumber = toNumber(gteValue);
      const lteNumber = toNumber(lteValue);
      const lteMaxNumber = toNumber(lteMax);

      const isDefaultRange =
        (gteNumber === null || gteNumber === 0) &&
        lteNumber !== null &&
        lteMaxNumber !== null &&
        lteNumber === lteMaxNumber;

      if (isDefaultRange) {
        searchParams.delete(gteKey);
        searchParams.delete(lteKey);
      }
    }

    return searchParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  submitCustomTagFilters(form) {
    const tagHandles = [
      ...new Set(
        [...form.querySelectorAll('.custom-menu-tag-filter input[name="filter.p.tag"]:checked:not(:disabled)')]
          .map((input) => input.dataset.tagHandle)
          .filter(Boolean)
      ),
    ];
    const url = new URL(window.location.href);
    url.searchParams.delete('filter.p.tag');
    url.searchParams.delete('tag');
    url.searchParams.delete('custom_tag');
    url.searchParams.delete('custom_page');
    tagHandles.forEach((handle) => url.searchParams.append('tag', handle));
    history.pushState({}, '', `${url.pathname}${url.search}`);
    FacetFiltersForm.renderCustomTagResultsFromUrl(false);
    return true;
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    const isCustomTagInput = event.target.closest('.custom-menu-tag-filter input[name="filter.p.tag"]');
    if (form && isCustomTagInput && FacetFiltersForm.usesCustomTagFiltering() && this.submitCustomTagFilters(form))
      return;
    if (form && FacetFiltersForm.usesCustomTagFiltering() && event.target.name === 'sort_by') {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('custom_page');
      history.pushState({}, '', `${url.pathname}${url.search}`);
      FacetFiltersForm.renderCustomTagResultsFromUrl(false);
      return;
    }
    if (form && FacetFiltersForm.usesCustomTagFiltering()) {
      const formParams = new URLSearchParams(this.createSearchParams(form));
      const url = new URL(window.location.href);
      [...new Set([...url.searchParams.keys()])]
        .filter((key) => key.startsWith('filter.'))
        .forEach((key) => url.searchParams.delete(key));
      formParams.forEach((value, key) => {
        if (key !== 'filter.p.tag' && key !== 'sort_by') url.searchParams.append(key, value);
      });
      url.searchParams.delete('custom_page');
      history.pushState({}, '', `${url.pathname}${url.search}`);
      FacetFiltersForm.renderCustomTagResultsFromUrl(false);
      return;
    }

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
			const facetDrawer = document.querySelector('.facets-drawer');
			
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          } else if (facetDrawer && window.innerWidth > 750 && form.id === 'FacetFiltersFormMobile') {
            forms.push(this.createSearchParams(form));
					}
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    event.currentTarget.closest('facet-remove')?.remove();
    if (FacetFiltersForm.usesCustomTagFiltering()) {
      const url = new URL(event.currentTarget.href);
      history.pushState({}, '', `${url.pathname}${url.search}`);
      FacetFiltersForm.renderCustomTagResultsFromUrl(false);
      return;
    }
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.renderRequestId = 0;
FacetFiltersForm.requestController = null;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.syncCustomMenuTagFilterActiveStates();
if (FacetFiltersForm.usesCustomTagFiltering() && FacetFiltersForm.getCustomSelectedTagHandles().size > 0) {
  FacetFiltersForm.renderCustomTagResultsFromUrl(false);
}

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
				element.addEventListener('change', this.onRangeChange.bind(this));
				element.addEventListener('keydown', this.onKeyDown.bind(this));
			}
    );
    this.querySelectorAll('.field__input').forEach((element) => {
      element.addEventListener('focus', () => element.value = '');
    });
    this.setMinAndMaxValues();
		this.controlSlider();
    this.controlInput();
    this.fillSlider();
  }
  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '' || minInput == NaN) maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

	fillSlider() {
    this.querySelectorAll(".facets__range").forEach(inputWrapper => {
      const inputsRange = inputWrapper.querySelectorAll(".field__range");
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const range = inputRangeTo.max - inputRangeTo.min;
      const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
      const toCurrent = inputRangeTo.value - inputRangeTo.min;
      const minRange = (fromCurrent / range) * 100;
      const maxRange = (toCurrent / range) * 100;

      inputWrapper.setAttribute("style", `--range-min: ${minRange}%; --range-max: ${maxRange}%`);
    });
  }

	controlSlider() {
    const inputRangeWrappers = this.querySelectorAll(".facets__range");
    const inputNumberWrappers = this.querySelectorAll(".facets__price-wrapper");

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll(".field__range");
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll(".field__input")[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll(".field__input")[1];

      inputRangeFrom.oninput = () => {
        let from = parseInt(inputRangeFrom.value, 10);
				if (!from) from = 0;
        const to = parseInt(inputRangeTo.value, 10);

        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        } else {
          inputNumberFrom.value = from;
        }
        this.fillSlider();
      };

      if (Number(inputRangeTo.value) <= 0) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = () => {
        let from = parseInt(inputRangeFrom.value, 10);
				if (!from) from = 0;
        const to = parseInt(inputRangeTo.value, 10);

        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        } else {
          inputNumberTo.value = from;
          inputRangeTo.value = from;
        }

        if (Number(inputRangeTo.value) <= 0) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }
        this.fillSlider();
      };
    });
  }

	controlInput() {
    const inputRangeWrappers = this.querySelectorAll(".facets__range");

    this.querySelectorAll(".facets__price-wrapper").forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll(".field__input");
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom = inputRangeWrappers[index].querySelectorAll(".field__range")[0];
      const inputRangeTo = inputRangeWrappers[index].querySelectorAll(".field__range")[1];

      inputNumberFrom.oninput = () => {
        let from = parseInt(inputNumberFrom.value, 10);
				if (!from) from = 0;
        const to = parseInt(inputNumberTo.value, 10);

        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        } else {
          inputRangeFrom.value = from;
        }
        this.fillSlider();
      };

      inputNumberTo.oninput = () => {
        let from = parseInt(inputNumberFrom.value, 10);
				if (!from) from = 0;
        const to = parseInt(inputNumberTo.value, 10);

        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        } else {
          inputRangeTo.value = from;
        }
        this.fillSlider();
      };
    });
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const facetLink = event.currentTarget;
    const facetUrl = new URL(facetLink.href);

    if (facetUrl.pathname !== window.location.pathname) {
      window.location.href = facetLink.href;
      return;
    }

    const form =
      this.closest('facet-filters-form') ||
      (this.closest('.active-facets-mobile')
        ? document.querySelector('#FacetFiltersFormMobile')?.closest('facet-filters-form')
        : null) ||
      document.querySelector('facet-filters-form');
    if (!form) {
      window.location.href = facetLink.href;
      return;
    }
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


if (!customElements.get('vertical-filter-button')) {
	class VerticalFilterButton extends HTMLElement {
		constructor() {
			super();
			this.toggleOpen = this.toggleOpen.bind(this);
			this.elements = {
				filter: document.querySelector('.facets-vertical'),
				grid: document.querySelector('.facets-vertical .product-grid'),
			}

			this.elements.focusableItems = this.elements.filter
        ? this.elements.filter.querySelectorAll('.facets-wrapper :is(input:not(.field__range), summary, select, button, a, textarea)')
        : [];
		}

		connectedCallback() {
			this.addEventListener('click', this.toggleOpen);
      if (this.hasAttribute('open') && this.elements.filter?.classList.contains('js-active')) {
        this.updateGridColumns('reset');
      }
      this.updateFocusableState(this.hasAttribute('open'));

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.toggleOpen();
        }
      });
		}

		disconnectedCallback() {
      this.removeEventListener('click', this.toggleOpen);
    }
		toggleOpen() {
      if (this.hasAttribute('open')) {
        this.removeAttribute('open');
				if (this.elements.filter) {
					this.elements.filter.classList.remove('js-active');
					this.updateGridColumns('increase');
					this.updateFocusableState(false);
				}
      } else {
        this.setAttribute('open', '');
				if (this.elements.filter) {
					this.elements.filter.classList.add('js-active');
					this.updateGridColumns('reset');
					this.updateFocusableState(true);
				}
      }
    }
    updateFocusableState(isOpen) {
			this.elements.focusableItems = this.elements.filter
        ? this.elements.filter.querySelectorAll('.facets-wrapper :is(input:not(.field__range), summary, select, button, a, textarea)')
        : [];
			if (this.elements.focusableItems.length == 0) return
			
      this.elements.focusableItems.forEach((el) => {
        el.tabIndex = isOpen ? 0 : -1;
      });
    }

		updateGridColumns(action) {
			this.elements.grid = document.querySelector('.facets-vertical .product-grid');

      if (!this.elements.grid) return;

      const gridClassMatch = this.elements.grid.className.match(/grid--(\d+)-col-desktop/);
      if (!gridClassMatch) return;

      let newColumns = parseInt(gridClassMatch[1], 10);

      if (action === 'increase') {
        newColumns = 4;
      } else if (action === 'reset') {
				newColumns = 3;
      }

      const newClass = `grid--${newColumns}-col-desktop`;
      this.elements.grid.className = this.elements.grid.className.replace(/grid--\d+-col-desktop/, newClass);
    }
	}

	customElements.define('vertical-filter-button', VerticalFilterButton);
}
